// extracted by mini-css-extract-plugin
export var background = "topImage-module--background--zoRsS";
export var firstImage = "topImage-module--firstImage--AF-8a";
export var top = "topImage-module--top--Rat7-";